import { notificationCenterMarkup } from './notificationCenterMarkup';

export const shellMarkup = String.raw`

<!-- Top Nav -->
<nav class="top-nav">
  <div class="nav-inner">
    <div style="display:flex;align-items:center;">
      <div class="nav-logo" data-proto-click="showView('home');setActiveTab('home')">
        <img class="nav-logo-mark" src="/assets/brand/deepmox-wordmark-320.png" alt="DeepMox">
      </div>
      <div class="nav-tabs" id="navTabs">
        <button class="nav-tab active" data-view="home" data-proto-click="showView('home');setActiveTab('home')">
          <span class="nav-tab-dot" style="background:var(--accent)"></span>Home
        </button>
        <button class="nav-tab" data-view="home-browse" data-proto-click="showView('home-browse');setActiveTab('home-browse')">
          <span class="nav-tab-dot" style="background:var(--cat-startup)"></span>Browse
        </button>
        <button class="nav-tab" data-view="community" data-proto-click="showView('community');setActiveTab('community')">
          <span class="nav-tab-dot" style="background:var(--cat-marketing)"></span>Community
        </button>
        <button class="nav-tab" data-view="github-trending" data-proto-click="showView('github-trending');setActiveTab('github-trending')">
          <span class="nav-tab-dot" style="background:#24292e"></span>GitHub Trending
        </button>
        <button class="nav-tab" data-view="ai-create" data-proto-click="showView('ai-create');setActiveTab('ai-create')">
          <span class="nav-tab-dot" style="background:var(--cat-ai)"></span>AI Create
        </button>
      </div>
    </div>
    <div class="nav-actions">
      <div class="theme-toggle" id="theme-toggle">
        <button data-theme-mode="reader" title="Reader" aria-label="Reader theme" data-proto-click="setThemeMode('reader')" class="active">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path><path d="M8 6h8"></path><path d="M8 10h6"></path></svg>
        </button>
        <button data-theme-mode="light" title="Light" aria-label="Light theme" data-proto-click="setThemeMode('light')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
        </button>
        <button data-theme-mode="dark" title="Dark" aria-label="Dark theme" data-proto-click="setThemeMode('dark')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
        </button>
        <button data-theme-mode="auto" title="System" aria-label="System theme" data-proto-click="setThemeMode('auto')">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
        </button>
      </div>
      <!-- round-14: top-nav "Preview account" — secondary CTA
           visible only to visitors. Sits between theme-toggle
           and the avatar button so the eye lands on it before
           the avatar dropdown. Toggles via showLoginState /
           hideLoginState alongside avatarLoggedIn / Out. -->
      <button id="navPreviewCta" class="nav-preview-cta" data-proto-click="showView('profile');setActiveTab('profile')" style="display:none;" aria-label="Preview your account">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
        <span>Preview account</span>
      </button>
      ${notificationCenterMarkup}
      <div class="avatar-dropdown-wrap">
        <button class="avatar-btn" id="avatarBtn" data-proto-click="toggleAvatarDropdown()" aria-label="Account menu">
              <svg id="avatarMark" viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" data-visitor-icon="1">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="12" cy="7" r="4" fill="none" stroke="currentColor" stroke-width="2"/>
                <path class="avatar-wave-hand" d="M18 8l1.5-3a1.2 1.2 0 0 0-2.2-1L16 6.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
        <div class="avatar-dropdown" id="avatarDropdown">
          <!-- Avatar dropdown content is rendered exclusively by
               renderAvatarDropdown(root, state) in avatarView.ts.
               Both containers ship empty here on purpose: any static
               markup duplicated here would create a second source of
               truth and resurrect the recurring "blank but clickable"
               popup bug. See avatarView.ts header for the contract. -->
          <div id="avatarLoggedIn" style="display: none;"></div>
          <div id="avatarLoggedOut" style="display: none;"></div>
        </div>
      </div>
    </div>
  </div>
</nav>

<!-- Bottom Tab Navigation (mobile only, ≤1024px via CSS)
     TikTok-style layout: Home / Browse / +Create (center FAB) / Social / Me
     Social view hosts Community + GitHub Trending sub-tabs.
     Me goes directly to Profile (no avatar dropdown on mobile). -->
<nav class="tab-nav" id="tabNav">
  <button class="tab-item active" data-tab="home" data-proto-click="showView('home');setActiveTab('home')">
    <svg class="tab-home-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" data-icon-source="lucide"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
    <svg class="tab-rocket-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" hidden aria-hidden="true" data-icon-source="lucide"><path d="M9 13a1 1 0 0 1-1-1H5.061a1 1 0 0 1-.75-1.811l6.836-6.835a1.207 1.207 0 0 1 1.707 0l6.835 6.835a1 1 0 0 1-.75 1.811H16a1 1 0 0 1-1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z"></path><path d="M9 20h6"></path></svg>
    <span class="tab-home-label">Home</span>
  </button>
  <button class="tab-item" data-tab="home-browse" data-proto-click="showView('home-browse');setActiveTab('home-browse')">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
    <span>Browse</span>
  </button>
  <button class="tab-item primary" data-tab="ai-create" data-proto-click="showView('ai-create');setActiveTab('ai-create')">
    <span class="tab-fab">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"></path><path d="M20 2v4"></path><path d="M22 4h-4"></path><circle cx="4" cy="20" r="2"></circle></svg>
    </span>
    <span>Create</span>
  </button>
  <button class="tab-item" data-tab="social" data-proto-click="showSocial('community')">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16.247 7.761a6 6 0 0 1 0 8.478"></path><path d="M19.075 4.933a10 10 0 0 1 0 14.134"></path><path d="M4.925 19.067a10 10 0 0 1 0-14.134"></path><path d="M7.753 16.239a6 6 0 0 1 0-8.478"></path><circle cx="12" cy="12" r="2"></circle></svg>
    <span>Social</span>
  </button>
  <button class="tab-item" data-tab="profile" data-proto-click="showView('profile');setActiveTab('profile')">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
    <span>Me</span>
  </button>
</nav>

`;
